import ApplicationController from "./application_controller";

export default class extends ApplicationController {
  getLicenseNumber() {
    const licenseState = this.element.value;
    fetch(`/baf/license_number?license_state=${licenseState}`)
      .then(response => response.json())
      .then(data => {
        const licenseNumberElement = document.getElementById("license_number_form_field");
        licenseNumberElement.value = data.license_number;
      }
    );
  }
}